import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { hoodRiverConfig } from "./data";

export default function HoodRiverPage() {
  return <OregonCityPageTemplate config={hoodRiverConfig} />;
}